// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relatedproducts{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    height: 90vh;
}
.relatedproducts h1{
    color: #171717;
    font-size: 50px;
    font-weight: 600;
}
.relatedproducts hr{
    width: 200px;
    height: 6px;
    border-radius: 10px;
    background: #252525;

}
.relatedproducts-item{
    margin-top: 50px;
    display: flex;
    gap: 30px;

}

@media(max-width:1280px){
    .relatedproducts{
        height: 70vh;
    }
    .relatedproducts h1{
        font-size: 40px;
    }
    .relatedproducts hr{
        width: 160px;
        height: 4px;
    }
    .relatedproducts-item{
        gap: 20px;
        margin-top: 30px;
    }

}
@media(max-width:1024px){
    .relatedproducts{
        height: 60vh;
    }
    .relatedproducts h1{
        font-size: 30px;
    }
    .relatedproducts hr{
        width: 120px;
        height: 3px;
    }
    .relatedproducts-item{
        gap: 15px;
        margin-top: 20px;
    }

}
@media(max-width:800px){
    .relatedproducts{
        height: 50vh;
        gap: 6px;
    }
    .relatedproducts h1{
        font-size: 20px;
    }
    .relatedproducts hr{
        width: 100px;
 
    }
    .relatedproducts-item{
        gap: 5px; 
    }

}
@media(max-width:500px){
    .relatedproducts{
        height: 90vh;
    }
    
    .relatedproducts-item{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px; 
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/RelatedProducts/RelatedProducts.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;;AAEb;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,YAAY;QACZ,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;;IAEhB;IACA;QACI,QAAQ;IACZ;;AAEJ;AACA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;AAEJ","sourcesContent":[".relatedproducts{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    height: 90vh;\n}\n.relatedproducts h1{\n    color: #171717;\n    font-size: 50px;\n    font-weight: 600;\n}\n.relatedproducts hr{\n    width: 200px;\n    height: 6px;\n    border-radius: 10px;\n    background: #252525;\n\n}\n.relatedproducts-item{\n    margin-top: 50px;\n    display: flex;\n    gap: 30px;\n\n}\n\n@media(max-width:1280px){\n    .relatedproducts{\n        height: 70vh;\n    }\n    .relatedproducts h1{\n        font-size: 40px;\n    }\n    .relatedproducts hr{\n        width: 160px;\n        height: 4px;\n    }\n    .relatedproducts-item{\n        gap: 20px;\n        margin-top: 30px;\n    }\n\n}\n@media(max-width:1024px){\n    .relatedproducts{\n        height: 60vh;\n    }\n    .relatedproducts h1{\n        font-size: 30px;\n    }\n    .relatedproducts hr{\n        width: 120px;\n        height: 3px;\n    }\n    .relatedproducts-item{\n        gap: 15px;\n        margin-top: 20px;\n    }\n\n}\n@media(max-width:800px){\n    .relatedproducts{\n        height: 50vh;\n        gap: 6px;\n    }\n    .relatedproducts h1{\n        font-size: 20px;\n    }\n    .relatedproducts hr{\n        width: 100px;\n \n    }\n    .relatedproducts-item{\n        gap: 5px; \n    }\n\n}\n@media(max-width:500px){\n    .relatedproducts{\n        height: 90vh;\n    }\n    \n    .relatedproducts-item{\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 20px; \n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
